import script from "./MenuSubCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSubCategory.vue?vue&type=script&setup=true&lang=js"

import "./MenuSubCategory.vue?vue&type=style&index=0&id=4abbceb2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4abbceb2"]])

export default __exports__